import gql from 'graphql-tag';

const STUDENT_SETTINGS_FRAGMENT = gql`
  fragment BaseStudentSettings on StudentSetting {
    id
    setting
    studentId
    value
    dateCreated
    dateUpdated
    app {
      id
    }
  }
`;

export default STUDENT_SETTINGS_FRAGMENT;
